export const API = {
    Login: {
        login: '/user/login',
        forgotPassword: '/user/forgot-password',
    },
    Employee: {
        list: '/employee/list',
        listAll: '/employee/list-all',
        create: '/employee/create',
        detailById: '/employee',
        update: 'employee/update',
        delete: '/employee/delete',
        addHourlyCharge: '/employee/add-hourly-charge',
        hourlyChargeHistory: '/employee/hourly-charge-history',
    },
    Additional: {
        companyList: '/get-company',
        jobTypes: '/get-job-types',
        locations: '/get-locations',
        departments: '/get-department',
        requestors: '/get-requestors',
        assignor: '/get-assignor',
        users: '/get-users',
    },
    Job: {
        list: '/job/list',
        employeeList: '/job/get-employees',
        create: '/job/create',
        delete: '/job/delete',
        requestorJobList: '/job/requestor-job-list',
        requestorListData: '/job/assignor-requestor-job-list',
        replaceEmployee: '/job/replace-employee',
        reverseReplaceEmployee: '/job/reverse-replace-employee',
        getReplacedEmployee: '/job/get-replaced-employees',
        getRequestorEmployeeList: '/job/get-requestor-employees-list',
        createCharge: '/job/add-hourly-charge',
        getChargeHistory: '/job/hourly-charge-history',
        report: '/job/report',
    },
    JobDetail: {
        list: '/job',
        update: '/job/update',
        addTimeSheet: '/job/time-sheet',
        updateTimeSheet: 'job/time-sheet/update',
        jobComplete: '/job/complete',
        updateInvoice: '/update-invoice',
    },
    Home: {
        jobOverView: '/dashboard/job-count',
        peopleOverView: '/dashboard/people-overview',
        chartOverView: '/dashboard/monthly-overview',
    },
    Admin: {
        list: '/admin/list',
        create: '/user/create',
        updateStatus: '/user/update-status',
        timeSpent: '/admin/time-spent',
        update: '/user/update',
        resetPassword: '/user/reset-password',
    },
    Roles: {
        list: '/roles/list',
        create: '/roles/create',
        update: '/roles/update',
    },
    RolePermission: {
        list: '/role-permission/list',
        listPermission: '/role-permission/list-permissions',
        create: '/role-permission/create',
    },
    Permissions: {
        list: '/permission/list',
        create: '/permission/create',
        update: '/permission/update',
        delete: '/permission/delete',
    },
    Tasks: {
        list: '/task/list',
        create: '/task/create',
        update: '/task/update',
        delete: '/task/delete',
    },
    TaskProgressNotes: {
        list: '/task-progress-note/list',
        create: '/task-progress-note/create',
        update: '/task-progress-note/update',
        delete: '/task-progress-note/delete',
    },
    Vouchers: {
        create: '/voucher/create',
        list: 'voucher/list',
        empList: 'voucher/list-employee',
        update: 'voucher/update',
        delete: 'voucher/delete',
        report: 'voucher/report',
        updatePaymentDate: 'voucher/update/payment-date',
        updateEmployeePayment: 'voucher/update/employee-payment',
        voucherCreate: '/voucher',
        verifyVoucher: '/voucher/verify-voucher',
        verifyEmpVoucher: '/voucher/verify-employee-payment',
    },

    Payment: {
        create: 'employee-payment/create',
        list: 'employee-payment/list',
        update: 'employee-payment/update',
        remainingPayment: 'employee-payment/get-remaining-payment',
    },
};
